<template>
  <section class="how-does-it-work bg-white relative lg:pb-28">
    <img
      src="/frontend/assets/how-does-it-work.jpg"
      class="hidden md:block ml-[15px] md:ml-0 md:absolute md:right-0 md:max-w-[350px] lg:max-w-max"
    >

    <div class="py-9 flex flex-wrap md:py-16">
      <div class="container">
        <div class="mt-8 w-full md:w-1/2 lg:pr-36 md:pc-12 md:flex md:content-center md:flex-wrap md:mt-0">
          <div class="w-full">
            <span class="w-[30px] h-[30px] bg-red text-white inline-block rounded-full text-center leading-8 font-bold">
              1.
            </span>
            <span class="text-red text-lg inline ml-2">
              {{ __('components.how-does-it-work.steps.0.title') }}
            </span>
          </div>

          <img
            src="/frontend/assets/how-does-it-work.jpg"
            class="block md:hidden ml-[15px] md:ml-0 md:absolute md:right-0 md:max-w-[350px] lg:max-w-max"
          >

          <h3 class="text-4xl font-bold mt-3 w-full">
            {{ __('components.how-does-it-work.steps.0.text') }}
          </h3>

          <p class="text-gray-300 mt-1 mb-3 w-full">
            {{ __('components.how-does-it-work.steps.0.extra-text') }}
          </p>

          <Link
            :href="localeRoute('frontend.index')"
            class="button-orange shadow-button-black inline-block mx-0 lg:mx-0"
          >
            {{ __('general.see-all-vips') }}
          </Link>
        </div>
      </div>
    </div>

    <div class="py-9  md:py-12 relative">
      <div class="container">
        <div class="flex flex-wrap">
          <div class="hidden md:block w-full md:w-1/2 md:pr-8">
            <img
              src="/frontend/assets/how-does-it-work-2.jpg"
              class="w-full rounded-lg"
            >
          </div>

          <div class="mt-8 w-full md:w-1/2 lg:pr-36 md:px-12 md:flex md:content-center md:flex-wrap md:mt-0">
            <div class="w-full">
              <span class="w-[30px] h-[30px] bg-red text-white inline-block rounded-full text-center leading-8 font-bold">
                2.
              </span>
              <span class="text-red text-lg inline ml-2">
                {{ __('components.how-does-it-work.steps.1.title') }}
              </span>
            </div>

            <img
              src="/frontend/assets/how-does-it-work-2.jpg"
              class="block md:hidden mt-3 w-full rounded-lg"
            >

            <h3 class="text-4xl font-bold mt-3 w-full">
              {{ __('components.how-does-it-work.steps.1.text') }}
            </h3>

            <p class="text-gray-300 mt-1 mb-3 w-full">
              {{ __('components.how-does-it-work.steps.1.extra-text') }}
            </p>
          </div>
        </div>
      </div>

      <img
        src="/frontend/assets/scribble-round-desktop.svg"
        class="hidden lg:block lg:absolute lg:right-[0px] lg:top-[25px]"
      >
    </div>

    <div class="py-9  md:py-12">
      <div class="container">
        <div class="flex flex-wrap">
          <div class="hidden md:block w-full md:w-1/2 md:pr-8 md:order-2">
            <div class="w-full rounded-lg overflow-hidden">
              <VideoPlayer
                controls
                :autoplay="true"
                :loop="true"
                :muted="true"
                src="/frontend/assets/homepage-video.mp4"
                class="rounded-lg"
              />
            </div>
          </div>

          <div class="mt-8 w-full md:w-1/2 lg:pr-36 md:px-12 md:flex md:content-center md:flex-wrap md:order-1 md:mt-0">
            <div class="w-full">
              <span class="w-[30px] h-[30px] bg-red text-white inline-block rounded-full text-center leading-8 font-bold">
                3.
              </span>
              <span class="text-red text-lg inline ml-2">
                {{ __('components.how-does-it-work.steps.2.title') }}
              </span>
            </div>

            <div class="block md:hidden w-full rounded-lg mt-3">
              <VideoPlayer
                controls
                :autoplay="true"
                :autostart="1"
                :loop="true"
                :muted="true"
                src="/frontend/assets/homepage-video.mp4"
                class="rounded-lg"
              />
            </div>

            <h3 class="text-4xl font-bold mt-3 w-full">
              {{ __('components.how-does-it-work.steps.2.text') }}
            </h3>

            <!-- eslint-disable vue/no-v-html -->
            <p
              class="text-gray-300 mt-1 mb-3 w-full"
              v-html="__('components.how-does-it-work.steps.2.extra-text')"
            />
            <!-- eslint-enable vue/no-v-html -->
          </div>
        </div>
      </div>
    </div>

    <img
      src="/frontend/assets/scribble-bottom-desktop.svg"
      class="hidden lg:block lg:absolute lg:right-[100px] lg:bottom-[50px]"
    >
  </section>
</template>
<script>
import VideoPlayer from './VideoPlayer.vue';
export default {
  components: {VideoPlayer},
};
</script>
